import React from 'react';
import { motion } from 'framer-motion';
import { FaQuoteLeft } from 'react-icons/fa';

const testimonials = [
  {
    text: "Un service exceptionnel et une équipe très professionnelle. Je recommande vivement Drive Inter pour leur expertise et leur réactivité.",
    author: 'Client Satisfait',
    company: 'Entreprise de Transport'
  },
  {
    text: "Grâce à Drive Inter, nous avons pu optimiser notre gestion administrative et nous concentrer sur notre cœur de métier.",
    author: 'Partenaire Fidèle',
    company: 'PME Industrielle'
  },
  {
    text: "Une collaboration fructueuse depuis plusieurs années. L'équipe est toujours disponible et à l'écoute de nos besoins.",
    author: 'Client Régulier',
    company: 'Société de Services'
  }
];

const Testimonials = () => {
  return (
    <section className="testimonials">
      <div className="container">
        <motion.div 
          className="section-header"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
        >
          <h2>Témoignages</h2>
          <p>Ce que nos clients disent de nous</p>
        </motion.div>
        <div className="testimonials-grid">
          {testimonials.map((testimonial, index) => (
            <motion.div
              key={index}
              className="testimonial-card"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              viewport={{ once: true }}
            >
              <div className="quote-icon">
                <FaQuoteLeft />
              </div>
              <p>"{testimonial.text}"</p>
              <div className="testimonial-author">
                <strong>{testimonial.author}</strong>
                <span>{testimonial.company}</span>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
